var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnowledgeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    height: 400,
    width: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6DEDB"
    },
    d: "M384.54,113.13h-3.2V62.04c0-10.84-8.78-19.62-19.62-19.62l0,0 C303.84,42.4,247.36,60.25,200,93.53C152.64,60.25,96.16,42.4,38.28,42.42c-10.83,0-19.61,8.78-19.61,19.61c0,0,0,0,0,0v51.09 h-3.21C6.92,113.13,0,120.06,0,128.59v187.04c-0.01,8.54,6.9,15.47,15.44,15.49c0.01,0,0.01,0,0.02,0h129.97 c8.13,0,15.82,3.71,20.87,10.09c14.66,18.61,41.63,21.82,60.24,7.17c2.66-2.1,5.07-4.5,7.17-7.17 c5.05-6.38,12.73-10.09,20.87-10.09h129.97c8.54,0,15.46-6.93,15.46-15.46V128.59C400,120.06,393.08,113.14,384.54,113.13z  M194.84,114.15v144.56c0,2.85,2.31,5.16,5.16,5.16s5.16-2.31,5.16-5.16V114.15c45.16-33.88,100.1-52.17,156.56-52.11v217.57 c-58.64-0.09-115.61,19.57-161.72,55.8c-46.11-36.23-103.07-55.89-161.72-55.8V62.04C94.74,61.98,149.68,80.27,194.84,114.15z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeIcon);
export default __webpack_public_path__ + "static/media/knowledge-icon.9b86d6b1a7016f7a0203fa46a3087694.svg";
export { ForwardRef as ReactComponent };